import database from '../../model/firebase/firebase';

export const companiesTypes = {
  GETTING_COMPANIES: 'companies/GETTING_COMPANIES',
  MANAGE_COMPANY: 'companies/MANAGE_COMPANY',
};

export const getCompanies = (companies) => ({
  type: companiesTypes.GETTING_COMPANIES,
  companies,
});

export const setCompanies = (companies) => ({
  type: companiesTypes.MANAGE_COMPANY,
  companies,
});

export const showCompaniesAdmin = () => async (dispatch, getState) => {
  const companies = (await database.collection(`${getState().platform.platformName}/data/companies`).get()).docs.map(
    (doc) => ({ ...doc.data() })
  );
  dispatch(getCompanies(companies));
};
